import React, { useState, useEffect } from 'react'
import { FiDownload } from 'react-icons/fi'
import { Lock, LockOpen, Visibility } from '@mui/icons-material'
import ToggleOnIcon from '@mui/icons-material/ToggleOn'
import ToggleOffIcon from '@mui/icons-material/ToggleOff'
import PersonIcon from '@mui/icons-material/Person'
import Skeleton from '@mui/material/Skeleton'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import CheckIcon from '@mui/icons-material/Check'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import Notfound from '../../../Notfound'
import { TableShimmer } from '../../../ShimmerUI'
import ClearIcon from '@mui/icons-material/Clear'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import api from '@/services/api'
import dayjs from 'dayjs'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  CardContent,
  Card,
  Box,
  IconButton,
  Tooltip,
  Pagination,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material'
import { toast } from 'react-toastify'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import RowsPerPageDropdown from '../RowsPerPageDropdown'
import { PatientDetailsDialog } from '@/components/patient-details'
import {
  Add as AddIcon,
} from '@mui/icons-material'
import { useDebounce } from '@/hooks/useDebounce'
import { EditIcon } from 'lucide-react'
interface Insurance {
  insuranceName: string
  insuranceType: string
  payerId: string
  policyNumber: string
  groupNumber: string
  policyHolder: string
  copay: number
  expiryDate: string
  insuranceCardUrl: string | null
}

interface Certificate {
  id: number
  name: string
  email: string
  role: string
  type: string
  isActive: boolean
  _id: string // Assuming this is unique and used to identify the patient
  status: string
}

const CertificateManager: React.FC = () => {
  const perPage = 10
  const prevSize = sessionStorage.getItem('prevSize')
  const ourPageSize = prevSize ? parseInt(prevSize, 10) : 10
  const [pageSize, setPageSize] = useState(ourPageSize)
  const [services, setServices] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [loadingForShimmer, setLoadingForShimmer] = useState(true)
  const [openToggle, setOpenToggle] = useState(false) // Dialog open state
  const [selectedPatientId, setSelectedPatientId] = useState<string | null>(
    null
  )

  const [open, setOpen] = useState(false)
  const [selectedJobs, setSelectedJobs] = useState<any[]>([])
  const [searchName, setSearchName] = useState('')
  const [accountStatusFilter, setAccountStatusFilter] = useState('All')
  const [isActive, setIsActive] = useState<boolean>(false)
  const [patients, setPatients] = useState<Certificate[]>([])
  const [loading, setLoading] = useState(false)
  const [certificateLoding, setCertificateLoding] = useState(false)
  const [exportLoading, setExportLoading] = useState<boolean>(false) // Loading state for export
  const [searchKeyword, setSearchKeyword] = useState<string>('')
  const [error, setError] = useState('')
  const [selectedPlanFilter, setSelectedPlanFilter] = useState('')
  const [selectedAccountStatus, setSelectedAccountStatus] = useState('')
  const [startDate, setStartDate] = useState<Date | null>(null)
  const [endDate, setEndDate] = useState<Date | null>(null)
  const [dobDate, setDobDate] = useState<Date | null>(null)
  const [totalRecords, setTotalRecords] = useState(0)
  const [totalActiveRecords, setTotalActiveRecords] = useState(0)
  const [totalInactiveRecords, setTotalInactiveRecords] = useState(0)
  const [sortField, setSortField] = useState<string>('')
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('asc')
  const [openPatientDetailsDialog, setOpenPatientDetailsDialog] =
    useState(false)
  const [selectedPatientForDetails, setSelectedPatientForDetails] =
    useState<any>(null)
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
  const [selectedPatientForDelete, setSelectedPatientForDelete] =
    useState<Certificate | null>(null)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [editCertificate, setEditCertificate] = useState<any>(null)

  const [formData, setFormData] = useState({
    name: editCertificate?.name || '',
    email: editCertificate?.email || '',
    password: editCertificate?.password || '',
    type: editCertificate?.type || 'MD',
    role: editCertificate?.role || 'certificate_manager'
  })
  const [selectedCertificateManagerForDelete, setSelectedCertificateManagerForDelete] = useState<any>(null)
  const [deleteDialog, setDeleteDialog] = useState(false)
  const [search, setSearch] = useState('')
  const debouncedSearch = useDebounce(search, 500)

  const handleOpen = (jobs: any[]) => {
    setSelectedJobs(jobs)
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    setSelectedJobs([])
  }

  const handleOpenPatientDetailsDialog = (patient: any) => {
    setSelectedPatientForDetails(patient)
    setOpenPatientDetailsDialog(true)
  }

  const handleClosePatientDetailsDialog = () => {
    setOpenPatientDetailsDialog(false)
    setSelectedPatientForDetails(null)
  }

  const handleExport = async () => {
    setExportLoading(true)
    try {
      const params: Record<string, any> = {
        accountStatus:
          selectedAccountStatus === 'Active'
            ? true
            : selectedAccountStatus === 'Inactive'
              ? false
              : undefined,
      }

      if (searchKeyword?.trim()) {
        params.search = searchKeyword
      }

      if (startDate) {
        params.startDate = getFormattedDateForAPI(startDate)
      }

      if (endDate) {
        params.endDate = getFormattedDateForAPI(endDate)
      }

      const response = await api.get('admin/patients/export', {
        responseType: 'blob',
        params,
      })

      // Create a blob from the response
      const blob = new Blob([response.data], {
        type: response.headers['content-type'] || 'text/csv',
      })

      // Create a download link
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url

      // Get filename from Content-Disposition header or use default
      // const contentDisposition = response.headers['content-disposition']
      let filename = 'patients_export.csv'
      // if (contentDisposition) {
      //   const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i)
      //   if (filenameMatch) {
      //     filename = filenameMatch[1]
      //   }
      // }

      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)

      toast.success('Export completed successfully')
    } catch (error) {
      console.error('Error exporting patients:', error)
      toast.error('Failed to export patients data')
    } finally {
      setExportLoading(false)
    }
  }

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setCurrentPage(page)
  }

  const handlePageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize)
    setCurrentPage(1)
    sessionStorage.setItem('prevSize', newPageSize.toString())
  }

  const handleAccountStatusChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setSelectedAccountStatus(event.target.value)
  }
  const getFormattedDateForAPI = (date: Date | null): string | null => {
    if (!date) return null

    const year = date.getFullYear()
    const month = ('0' + (date.getMonth() + 1)).slice(-2)
    const day = ('0' + date.getDate()).slice(-2)

    return `${year}-${month}-${day}` // YYYY-MM-DD format
  }
  const fetchCertificateManager = async (page?: number) => {
    setLoading(true)
    setError('')
    try {
      setLoadingForShimmer(true)
      const params: Record<string, any> = {
        page: page || currentPage, // Default to currentPage if page is not provided
        limit: pageSize,
        accountStatus:
          selectedAccountStatus === 'Active'
            ? true
            : selectedAccountStatus === 'Inactive'
              ? false
              : undefined,
      }

      if (searchKeyword?.trim()) {
        params.search = searchKeyword
      }
      if (startDate) {
        params.startDate = getFormattedDateForAPI(startDate)
      }

      if (endDate) {
        params.endDate = getFormattedDateForAPI(endDate)
      }

      if (dobDate) {
        params.dob = getFormattedDateForAPI(dobDate)
      }

      // Add sorting parameters
      if (sortField) {
        params.sortField = sortField
        params.sortOrder = sortOrder
      }

      const response = await api.get(`admin/admin-list?search=${debouncedSearch}`, {
        params,
      })

      if (response?.data?.data) {
        setPatients(response.data.data)
      } else {
        setError('No patients data found')
      }

      const pagination = response?.data?.pagination;
      if (pagination) {
        setTotalPages(Number(pagination.totalPages) || 1);
        setTotalRecords(Number(pagination.total) || 0);
      } else {
        const recordsCount = response?.data?.totalRecords || response?.data?.stats?.totalPatients || 0;
        setTotalRecords(recordsCount)
        setTotalPages(Math.ceil(recordsCount / pageSize) || 1)
      }
      setTotalActiveRecords(response?.data?.stats?.totalActivePatients)
      setTotalInactiveRecords(response?.data?.stats?.totalInactivePatients)
    } catch (err: any) {
      console.error(err)
      setError('Failed to fetch patients')
    } finally {
      setLoadingForShimmer(false)
      setLoading(false)
    }
  }

  const handleReset = () => {
    setSearch('')
    setCurrentPage(1)
  }

  const handleSort = (field: string) => {
    if (sortField === field) {
      // Toggle sort order if same field
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')
    } else {
      // Set new field and default to ascending
      setSortField(field)
      setSortOrder('asc')
    }
  }

  const getSortIcon = (field: string) => {
    if (sortField !== field) {
      return <UnfoldMoreIcon className="w-4 h-4 ml-1" />
    }
    return sortOrder === 'asc' ? (
      <KeyboardArrowUpIcon className="w-4 h-4 ml-1" />
    ) : (
      <KeyboardArrowDownIcon className="w-4 h-4 ml-1" />
    )
  }


  useEffect(() => {
    fetchCertificateManager(currentPage)
  }, [
    debouncedSearch,
    pageSize,
    currentPage
  ])

  const formatDate = (dateString: string) => {
    const date = new Date(dateString)
    const dd = String(date.getDate()).padStart(2, '0') // Day
    const mm = String(date.getMonth() + 1).padStart(2, '0') // Month
    const yyyy = date.getFullYear() // Full year
    return `${dd}-${mm}-${yyyy}` // Return formatted date as DD-MM-YYYY
  }

  const handleOpenToggle = (certificateId: string, currentStatus: string) => {
    setSelectedPatientId(certificateId) // Set the selected patient to toggle
    const status = currentStatus === 'Active' ? true : false
    setIsActive(status) // Set the current status of the patient (active or inactive)
    setOpenToggle(true) // Open the confirmation dialog
  }
  const handleConfirmToggle = async () => {
    if (!selectedPatientId) return // Exit if no patient is selected
    setLoading(true) // Start loading

    const newStatus = !isActive // Toggle the status
    try {
      const response = await api.patch(
        `admin/change-status/${selectedPatientId}`,
        {
          status: newStatus === true ? 'Active' : 'Inactive',
        }
      )

      if (response.status === 200) {
        setIsActive(newStatus) // Toggle status locally
        toast.success(
          `Patient status updated to ${newStatus ? 'Active' : 'Inactive'}`
        )
      }

      setOpenToggle(false) // Close the dialog after success
      fetchCertificateManager() // Optionally refresh the patient list
    } catch (error) {
      console.error('Error updating the patient status:', error)
      toast.error('Failed to update patient status')
    } finally {
      setLoading(false) // Stop loading
    }
  }


  const handleCloseDeleteDialog = () => {

    setDeleteDialog(false)
    setSelectedCertificateManagerForDelete(null)
    setEditCertificate(null)
    setFormData({
      name: '',
      email: '',
      password: '',
      type: 'MD',
      role: 'certificate_manager'
    })

  }

  const handleConfirmDelete = async () => {
    if (!selectedCertificateManagerForDelete?._id) return

    setDeleteLoading(true)
    try {
      const response = await api.delete(`admin/${selectedCertificateManagerForDelete._id}`)
      if (response.status === 200) {
        toast.success('Certificate Manager deleted successfully')
        handleCloseDeleteDialog()
        fetchCertificateManager()
      }

    } catch (error: any) {
      console.error('Error deleting certificate manager:', error)
      toast.error(error?.response?.data?.message || 'Failed to delete certificate manager')
    } finally {
      setDeleteLoading(false)
    }
  }

  const handleOpenDialog = () => {
    setEditCertificate(null)
    setFormData({
      name: '',
      email: '',
      password: '',
      type: 'MD',
      role: 'certificate_manager'
    })
    setOpenDialog(true)
  }

  const handleEditDialog = (certificate: any) => {
    setEditCertificate(certificate)
    setFormData({
      name: certificate?.name || '',
      email: certificate?.email || '',
      password: '',
      type: certificate?.type || 'MD',
      role: certificate?.role || 'certificate_manager'
    })
    setOpenDialog(true)
  }

  const handleCloseDialog = () => {
    setOpenDialog(false)
    setEditCertificate(null)
    setFormData({
      name: '',
      email: '',
      password: '',
      type: 'MD',
      role: 'certificate_manager'
    })
  }
  const handleSubmit = async () => {
    if (!formData.name) {
      toast.error('Please enter name')
      return
    }
    if (!formData.email) {
      toast.error('Please enter email')
      return
    }
    if (!formData.password) {
      toast.error('Please enter password')
      return
    }
    if (!formData.role) {
      toast.error('Please select role')
      return
    }
    if (!formData.type) {
      toast.error('Please select type')
      return
    }

    const payload = { ...formData }


    try {
      if (editCertificate) {
        setCertificateLoding(true)
        const response = await api.put(`admin/update/${editCertificate._id}`, payload)
        if (response.status === 200) {
          toast.success('Certificate Manager updated successfully')
          handleCloseDialog()
          fetchCertificateManager()
        }
      } else {
        setCertificateLoding(true)
        const response = await api.post('admin/signup', payload)
        if (response.status === 201) {
          toast.success('Certificate Manager added successfully')
          handleCloseDialog()
          fetchCertificateManager()
        }
      }
    } catch (error: any) {
      console.error('Error adding admin:', error)
      toast.error(error?.response?.data?.message || 'Failed to add admin')
    } finally {
      setCertificateLoding(false)
    }
  }
  const removeUnderscor = (str: string) => {
    return str.split('_').join(' ');
  }





  return (
    <div className="p-6 mx-auto max-w-7xl">
      {/* Header */}
      <div className="flex flex-col items-start justify-between gap-4 mb-6 sm:flex-row sm:items-center">
        <h5 className="text-2xl font-semibold text-[#6E7B8B]">
          Certification Admins Management
        </h5>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => handleOpenDialog()}
          sx={{
            bgcolor: '#5BC0BE',
            '&:hover': { bgcolor: '#49a9a7' },
            textTransform: 'none',
          }}
        >
          Add Certification Admin
        </Button>
      </div>
      {/* Certificate filter card */}
      <Card
        sx={{
          height: '100%',
          cursor: 'pointer',
          boxShadow: 2,
          padding: 2,
          mb: 3,
          transition: 'all 0.3s ease',
          '&:hover': {
            boxShadow: 4,
          },
        }}
      >
        <CardContent>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-5">
            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Search Name
              </label>
              <input
                type="text"
                value={search}
                onChange={e => {
                  setSearch(e.target.value)
                  setCurrentPage(1)
                }}
                placeholder="Search..."
                className="w-full border border-gray-300 rounded-lg px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-[#026730] focus:border-transparent"
              />
            </div>

            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Box display="flex" alignItems="flex-start" gap={2} width="100%">

                <Box display="flex" alignItems="center">
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleReset}
                    sx={{
                      borderRadius: 2,
                      width: '113px',
                      marginTop: '24px',
                    }}
                  >
                    Reset
                  </Button>
                </Box>
              </Box>
            </LocalizationProvider>
          </div>
        </CardContent>
      </Card>


      {/* Certificate Manager Table */}
      <div className="overflow-hidden bg-white rounded-lg shadow">
        <div className="overflow-x-auto">
          <table className="min-w-full">
            <thead className="bg-gray-50">
              <tr className="text-sm text-left text-white uppercase bg-[#5BC0BE]">
                <th
                  className="px-6 py-3 "
                  onClick={() => handleSort('firstName')}
                >
                  <div className="flex items-center">
                    Name
                    {getSortIcon('firstName')}
                  </div>
                </th>
                <th
                  className="px-6 py-3 cursor-pointer"
                  onClick={() => handleSort('email')}
                >
                  <div className="flex items-center">
                    Email
                    {getSortIcon('email')}
                  </div>
                </th>
                <th
                  className="px-6 py-3 cursor-pointer"
                  onClick={() => handleSort('role')}
                >
                  <div className="flex items-center">
                    Role
                    {getSortIcon('role')}
                  </div>
                </th>
                <th
                  className="px-6 py-3 cursor-pointer"
                  onClick={() => handleSort('type')}
                >
                  <div className="flex items-center">
                    Type
                    {getSortIcon('type')}
                  </div>
                </th>
                <th className="px-6 py-3">Account Status</th>
                <th className="px-6 py-3 text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {loadingForShimmer ? (
                <TableShimmer columns={10} />
              ) : patients?.length === 0 ? (
                <tr>
                  <td colSpan={20} className="p-4 text-center">
                    <Notfound />
                  </td>
                </tr>
              ) : (
                patients?.map(certificate => (
                  <tr
                    key={certificate._id || certificate.id}
                    className="hover:bg-gray-50"
                  >
                    <td className="px-6 py-4 min-w-[200px]">

                      <span
                        role="button"
                        tabIndex={0}

                      >
                        {certificate?.name}
                      </span>
                    </td>
                    <td className="px-6 py-4">{certificate?.email}</td>
                    <td className="px-6 py-4 min-w-[200px]">
                      {removeUnderscor(certificate?.role)}
                    </td>
                    <td className="px-6 py-4 min-w-[200px]">
                      {certificate?.type}
                    </td>
                    <td className="px-6 py-4">
                      <span
                        className={`px-2 py-1 rounded-full text-xs font-medium border ${certificate?.status === 'Active'
                          ? 'border-green-500 text-green-600'
                          : 'border-red-500 text-red-600'
                          }`}
                      >
                        {certificate?.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-center">
                      <div className="flex items-center justify-center gap-1">
                        <Tooltip placement="top" title={certificate?.status === 'Active' ? 'Deactivate' : 'Activate'}
                          arrow
                        >
                          <IconButton
                            onClick={() =>
                              handleOpenToggle(certificate?._id, certificate?.status)
                            }
                          >
                            {certificate?.status === 'Active' ? (
                              <ToggleOnIcon
                                sx={{ fontSize: 32, color: '#10b981' }}
                              />
                            ) : (
                              <ToggleOffIcon
                                sx={{ fontSize: 32, color: '#ef4444' }}
                              />
                            )}
                          </IconButton>
                        </Tooltip>
                        {/* edit certificate manager */}
                        <Tooltip placement="top" title="Edit Certificate" arrow>
                          <IconButton
                            onClick={() => handleEditDialog(certificate)}
                            sx={{
                              color: '#10b981',
                              '&:hover': {
                                bgcolor: 'rgba(16, 185, 129, 0.08)',
                              },
                            }}
                          >
                            <EditIcon />
                          </IconButton>
                        </Tooltip>
                        {/* delete certificate manager */}
                        <Tooltip placement="top" title="Delete Certificate" arrow>
                          <IconButton
                            onClick={() => {
                              setDeleteDialog(true)
                              setSelectedCertificateManagerForDelete(certificate)
                            }}
                            sx={{
                              color: '#dc2626',
                              '&:hover': {
                                bgcolor: 'rgba(220, 38, 38, 0.08)',
                              },
                            }}
                          >
                            <DeleteForeverIcon sx={{ fontSize: 24 }} />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className="flex justify-center mt-3">
        <div className="flex items-center gap-4">
          <RowsPerPageDropdown
            pageSize={pageSize}
            onPageSizeChange={handlePageSizeChange}
          />
        </div>
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handlePageChange}
          className="mt-2 mt-md-0"
          style={{
            display: 'flex',
            justifyContent: 'center',
          }}
        />
      </div>

      {/* active and inactive dialoge */}
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>Posted Jobs</DialogTitle>
        <DialogContent dividers>
          {selectedJobs.length > 0 ? (
            <Paper>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Job ID</TableCell>
                    <TableCell>Service Type</TableCell>
                    <TableCell>Status</TableCell>
                    {/* <TableCell>Provider Name</TableCell> */}
                    <TableCell>Posted Date</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {selectedJobs.map(job => (
                    <TableRow key={job.jobId}>
                      <TableCell>{job.jobId}</TableCell>
                      <TableCell>{job.jobType}</TableCell>
                      <TableCell>{job.status}</TableCell>
                      {/* <TableCell>{job.assignedTherapist || 'N/A'}</TableCell> */}
                      <TableCell>{formatDate(job.postedDate)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Paper>
          ) : (
            <Typography>No jobs found.</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="contained" color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      {/* Active/incative */}
      <Dialog open={openToggle} onClose={() => setOpenToggle(false)}>
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          Are you sure you want to {isActive ? 'deactivate' : 'activate'} this
          patient?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenToggle(false)} disabled={loading}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirmToggle}
            color="primary"
            variant="contained"
            disabled={loading}
          >
            {loading ? 'Updating...' : isActive ? 'Deactivate' : 'Activate'}
          </Button>
        </DialogActions>
      </Dialog>


      {/* Add/Edit Dialog */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          {editCertificate ? 'Edit Certificate Manager' : 'Add New Certificate Manager'}
        </DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection="column" gap={2} mt={1}>
            <TextField
              fullWidth
              label="Name"
              value={formData.name}
              onChange={e => setFormData({ ...formData, name: e.target.value })}
              required
              placeholder="Enter Name"
              autoComplete="off"
            />
            <TextField
              fullWidth
              label="Email"
              value={formData.email}
              onChange={e => setFormData({ ...formData, email: e.target.value })}
              required
              placeholder="Enter Email"
              autoComplete="off"
            />
            <TextField
              fullWidth
              label="Password"
              type="password"
              value={formData.password}
              onChange={e => setFormData({ ...formData, password: e.target.value })}
              required={!editCertificate}
              placeholder="Enter Password"
              autoComplete="new-password"
            />
            <FormControl fullWidth>
              <InputLabel id="role-select-label">Role</InputLabel>
              <Select
                labelId="role-select-label"
                value={formData.role}
                label="Role"
                onChange={e => setFormData({ ...formData, role: e.target.value })}
                required
              >
                <MenuItem value="certificate_manager">Certificate Manager</MenuItem>
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="status-select-label">Type</InputLabel>
              <Select
                labelId="status-select-label"
                label="Type"
                value={formData.type}
                onChange={e => setFormData({ ...formData, type: e.target.value })}
                required
              >
                <MenuItem value="MD">MD</MenuItem>
                <MenuItem value="NP">NP</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} disabled={loading}>
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            disabled={certificateLoding}
            sx={{ bgcolor: '#5BC0BE', '&:hover': { bgcolor: '#49a9a7' } }}
          >
            {certificateLoding ? 'Submitting...' : editCertificate ? 'Update' : 'Submit'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* delete dialog for certificate manager */}
      <Dialog
        open={deleteDialog}
        onClose={handleCloseDeleteDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Delete Certificate Manager
        </DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection="column" gap={2} mt={1}>
            <Typography variant="body1">
              Are you sure you want to delete this certificate manager?
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} disabled={loading}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            variant="contained"
            disabled={deleteLoading}
            sx={{ bgcolor: '#5BC0BE', '&:hover': { bgcolor: '#49a9a7' } }}
          >
            {deleteLoading ? 'Deleting...' : 'Delete'}
          </Button>
        </DialogActions>
      </Dialog>
      <ToastContainer />
    </div>
  )
}

export default CertificateManager
